<template>
    <div class="analysisTable">
        <div class="analysisTable__header">
            <div class="analysisTable__header--icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="14" viewBox="0 0 23 14" fill="none">
  <path d="M15.3293 1H21.6979M21.6979 1V7.36857M21.6979 1L12.7023 9.99561C12.5534 10.1415 12.3534 10.2232 12.145 10.2232C11.9366 10.2232 11.7366 10.1415 11.5878 9.99561L7.92582 6.33368C7.77702 6.18782 7.57695 6.10611 7.36857 6.10611C7.16019 6.10611 6.96012 6.18782 6.81132 6.33368L1 12.145" stroke="#3682F3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
            </div>
            <div class="analysisTable__header--title">Subpontuações</div>
        </div>
        <div class="analysisTable__content" v-if="!isLoading">
            <div class="analysisTable__content--list">
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Dist.End. Cobrança até local - IP</div>
                            <div class="item__container--value">{{ billingAddressDistanceToIpLocation }}</div>
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Navegador</div>
                            <div class="item__container--value">{{ browser }}</div>
                        </div>
                    </div>
                </div>
                <!-- <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Estorno</div>
                            <div class="item__container--value">{{ '--' }}</div>
                        </div>
                    </div>
                </div> -->
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">País</div>
                            <div class="item__container--value">{{ country }}</div>
                            
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Incompatibilidade de país</div>
                            <div class="item__container--value">{{ countryMismatch }}</div>
                            
                        </div>
                    </div>
                </div>
                <!-- <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Dispositivo</div>
                            <div class="item__container--value">{{ '--' }}</div>
                            
                        </div>
                    </div>
                </div> -->
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Endereço de email</div>
                            <div class="item__container--value">{{ emailAddress }}</div>
                            
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Domínio do email</div>
                            <div class="item__container--value">{{ emailDomain }}</div>
                            
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Mandato de email</div>
                            <div class="item__container--value">{{ emailTenure }}</div>
                            
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Posse de IP</div>
                            <div class="item__container--value">{{ ipTenure }}</div>
                            
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Número de identificação do emissor</div>
                            <div class="item__container--value">{{ issuerIdNumber }}</div>
                            
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Valor do pedido</div>
                            <div class="item__container--value">{{ orderAmount }}</div>
                            
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Numero de telefone</div>
                            <div class="item__container--value">{{ phoneNumber }}</div>
                            
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item no-border">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Hora do dia</div>
                            <div class="item__container--value">{{ timeOfDay }}</div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="row justify-content-center p-5">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'AnalysisTableClient',
    props: {
        data: {
            type: Object,
            required: true
        },
        totalizer: {
            type: Object,
            required: false
        },
    },
    computed: {
        isLoading() {
            return this.$store.getters["getLoadingAnalysis"]
        },
        billingAddressDistanceToIpLocation() {
            return JSON.parse(this.data.risk_body.subscores.billing_address_distance_to_ip_location)
        },
        browser() {
            if (this.data && this.data.risk_body && this.data.risk_body.subscores && this.data.risk_body.subscores.browser) {
                return JSON.parse(this.data.risk_body.subscores.browser);
            } else {
                return "Sem dados";
            }
        },
        country() {
            if (this.data && this.data.risk_body && this.data.risk_body.subscores && this.data.risk_body.subscores.country) {
                return JSON.parse(this.data.risk_body.subscores.country);
            } else {
                return "Sem dados";
            }
        },
        countryMismatch() {
            if(this.data && this.data.risk_body && this.data.risk_body.subscores && this.data.risk_body.subscores.country_mismatch) {
                return JSON.parse(this.data.risk_body.subscores.country_mismatch)
            }else {
                return "Sem dados";
            }
        },
        emailAddress() {
            if (this.data && this.data.risk_body && this.data.risk_body.subscores && this.data.risk_body.subscores.email_address) {
                return JSON.parse(this.data.risk_body.subscores.email_address);
            } else {
                return "Sem dados";
            }
        },
        emailDomain() {
            if (this.data && this.data.risk_body && this.data.risk_body.subscores && this.data.risk_body.subscores.email_domain) {
                return JSON.parse(this.data.risk_body.subscores.email_domain);
            } else {
                return "Sem dados";
            }
        },
        emailTenure() {
            if (this.data && this.data.risk_body && this.data.risk_body.subscores && this.data.risk_body.subscores.email_tenure) {
                return JSON.parse(this.data.risk_body.subscores.email_tenure);
            } else {
                return "Sem dados";
            }
        },
        ipTenure() {
            if (this.data && this.data.risk_body && this.data.risk_body.subscores && this.data.risk_body.subscores.ip_tenure) {
                return JSON.parse(this.data.risk_body.subscores.ip_tenure);
            } else {
                return "Sem dados";
            }
        },
        issuerIdNumber() {
            if (this.data && this.data.risk_body && this.data.risk_body.subscores && this.data.risk_body.subscores.issuer_id_number) {
                return JSON.parse(this.data.risk_body.subscores.issuer_id_number);
            } else {
                return "Sem dados";
            }
        },
        orderAmount() {
            if (this.data && this.data.risk_body && this.data.risk_body.subscores && this.data.risk_body.subscores.order_amount) {
                return JSON.parse(this.data.risk_body.subscores.order_amount);
            } else {
                return "Sem dados";
            }
        },
        phoneNumber() {
            if (this.data && this.data.risk_body && this.data.risk_body.subscores && this.data.risk_body.subscores.phone_number) {
                return JSON.parse(this.data.risk_body.subscores.phone_number);
            } else {
                return "Sem dados";
            }
        },
        timeOfDay() {
            if (this.data && this.data.risk_body && this.data.risk_body.subscores && this.data.risk_body.subscores.time_of_day) {
                return JSON.parse(this.data.risk_body.subscores.time_of_day);
            } else {
                return "Sem dados";
            }
        },
    },
};
</script>

<style scoped lang="scss">
.analysisTable {
    width: 100%;
    margin: 20px 0px 0px 0px;

    &__header {
        padding: 0px 20px;
        display: flex;
        justify-content: flex-start;

        &--icon {
            width: 20.698px;
            height: 20.698px;
            flex-shrink: 0;
        }

        &--title {
            color: #3682F3;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-left: 14px;
        }
    }

    &__content {
        height: auto;
        width: 100%;

        hr {
            background: #E5E5E5;
        }

        &--list {
            height: auto;
            width: 100%;
            margin: 20px 0px;

            .item {
                border-bottom: solid 1px #E5E5E5;
                position: relative;

                &__container {
                    padding: 20px;

                    &--title {
                        color: #B1B1B1;
                        font-size: 0.8em;
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;
                    }

                    &--value {
                        color: #141414;
                        font-size: 0.9em;
                        font-style: normal;
                        font-weight: 600;
                        line-height: normal;
                        width: calc(100% - 40px);
                        overflow-x: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }

                    &--pill {
                        position: absolute;
                        right: 20px;
                        top: 30%;
                        width: auto;
                        font-size: 0.7em;
                        padding: 4px 10px;
                        font-size: 12px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: normal;
                        border-radius: 50px;


                    }
                }

            }

            .no-border .item {
                border-bottom: none;
            }

        }
    }
}

.blue {
    background: rgba(54, 130, 243, 0.10);
    color: #3682F3;
}

.red {
    background: rgba(255, 95, 95, 0.10);
    color: #FF5F5F;
}
</style>